<div class="col-xs-12 sp-0 height-full">
    <ng-content></ng-content>
</div>
